import { createContext, useContext, ReactNode, useState } from 'react';

import { useCurrentSupportUser } from '@/features/dashboard-users/hooks/useCurrentSupportUser';

export const STEPS = {
  REGISTER: 0,
  REGISTER_SUCCESS: 1,
  REGISTER_FAIL: 2,
  CHANGE_PASSWORD: 3,
  AUTH: 4,
  AUTH_FAIL: 5,
};

export interface IAuth2FaContext {
  currentStep: number;
  setCurrentStep: (step: number) => void;
  onBack: () => void;
}

export const Auth2FaContext = createContext<IAuth2FaContext>({} as IAuth2FaContext);

interface IAuth2FaProvider {
  children: ReactNode;
  onBack: () => void;
}

export function Auth2FaProvider({ onBack, children }: IAuth2FaProvider) {
  const {
    accessTokenDecoded: { secureKeyId },
    shouldChangePassword,
  } = useCurrentSupportUser();

  const [currentStep, setCurrentStep] = useState(
    shouldChangePassword ? STEPS.CHANGE_PASSWORD : secureKeyId ? STEPS.AUTH : STEPS.REGISTER,
  );

  return (
    <Auth2FaContext.Provider
      value={{
        onBack,
        currentStep,
        setCurrentStep,
      }}
    >
      {children}
    </Auth2FaContext.Provider>
  );
}

export const useAuth2FaContext = () => useContext(Auth2FaContext);
